import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'spk-tab-pane',
  templateUrl: './spk-tab-pane.component.html',
  styleUrls: ['./spk-tab-pane.component.scss']
})
export class SpkTabPaneComponent implements OnInit {
  @Input() name: string;
  @Input() active: boolean;
  @Input() class: string;
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/framework/spk/layouts/tabs/spk-tab-pane/spk-tab-pane.component.ts